<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/NetworkIDTs">Financial Services</b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/NetworkIDTs">Network IDTs</b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ networkIDT.famisDepartment }} / {{ networkIDT.sl }} - {{ networkIDT.sa }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <AppLoadingContainer :predicate="!isLoaded">
      <form @submit.prevent="onSubmit()">
        <div class="card">
          <div class="bg-dark card-header text-white">Edit Network IDT</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-12 form-group">
                <label for="sl">SL</label>
                <input class="form-control" v-model="networkIDT.sl" disabled />
              </div>
              <div class="col-md-4 col-sm-12 form-group">
                <label for="sa">SA</label>
                <input class="form-control" v-model="networkIDT.sa" disabled />
              </div>
              <div class="col-md-4 col-sm-12 form-group">
                <label for="famisDepartment">FAMIS Department</label>
                <input class="form-control" v-model="networkIDT.famisDepartment" disabled />
              </div>
              <div class="col-md-4 col-sm-12 form-group">
                <label for="amountCharged">Amount Charged</label>
                <input class="form-control" v-model="networkIDT.amountCharged" type="number" min="0.01" placeholder="Amount Charged" />
                <transition name="fade">
                  <AppNotification type="danger" v-if="$v.networkIDT.amountCharged.$invalid && submissionAttempted">
                    {{ "Amount Charged must be left blank or given a number greater than 0" }}
                  </AppNotification>
                </transition>
              </div>
            </div>
          </div>
          <div class="card-footer d-print-none text-right">
            <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Submit</button>
            <RouterLink :to="{ name: 'NetworkIDTs' }" class="btn btn-danger">Back</RouterLink>
          </div>
        </div>
      </form>
    </AppLoadingContainer>
  </div>
</template>

<script>
import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
import NetworkIDTService from "@/services/NetworkIDTsService";
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import { ToastType } from "@/services/models/shared/ToastType";

export default {
  components: {
    AppLoadingContainer,
  },
  data() {
    return { 
      networkIDT: {
        sl: null,
        sa: null,
        famisDepartment: null,
        amountCharged: null,
      },
      isSubmitting: false,
      isLoaded: false,
    };
  },
  methods: {
    onSubmit() {
      const vm = this;

      vm.networkIDT.amountCharged = parseFloat(vm.networkIDT.amountCharged);

      const networkIDTData = {
        sl: vm.networkIDT.sl,
        sa: vm.networkIDT.sa,
        famisDepartment: vm.networkIDT.famisDepartment,
        amountCharged: vm.networkIDT.amountCharged,
      };

      vm.isSubmitting = true;
      NetworkIDTService.updateNetworkIDT(networkIDTData)
        .then(() => {
          vm.alert(ToastType.Success, 'The amount charged was successfully updated');
        })
        .catch(() => {
          vm.alert(ToastType.Danger, 'Account could not be updated');
        })
        .finally(() => {
          vm.isSubmitting = false;
        });
    },
    loadData() {
      const { sl, sa, famisDepartment, amountCharged } = this.$route.params;

      this.networkIDT = {
        sl,
        sa,
        famisDepartment,
        amountCharged: parseFloat(amountCharged), 
      };
      this.isLoaded = true;
    },
  },
  created() {
    this.loadData();
  },
  validations: {
    networkIDT: {
      amountCharged: { 
        validAmount(value) { 
          return value === null || value > 0; 
        },
      },
    },
  },
};
</script>

